import React from "react";
import { styled } from "@mui/material/styles";
import FontAwesomeIcon from "modules/shared/components/icon/font-awesome-icon";
import Colors from "theme/tokens/colors";
import Typography from "@mui/material/Typography";

const ErrorContainer = styled("div")`
  display: flex;
  margin-top: 4px;
  align-items: center;
`;

const ErrorMessage = styled(Typography)`
  padding-left: 8px;
  padding-bottom: 1px;
  color: ${Colors.CONTEXT_DANGER_200};
  font-size: 14px;
  font-weight: 700;
`;

const ERROR_MESSAGES = {
  TRANSACTION_FILE_ERROR:
    "O nome do arquivo não contém um id de transação válido, use somente o número da Coluna A da planilha enviada por e-mail.",
  TRANSACTION_FILE_ERROR_COMPANY:
    "O id da transação do arquivo não é válido para a companhia apresentada.",
  EXTENSION_FILE_ERROR: "Formato inválido, aceitamos arquivos em JPG ou PDF.",
  SIZE_FILE_ERROR: "O limite de 15MB foi excedido e não será possível enviar esse documento.",
  DISPUTE_BLOCKED_ERROR: "Já recebemos um documento referente a essa transação, o que impede o envio de um novo arquivo."
};

export default function FileItemError({ errorCode }) {
  return (
    <ErrorContainer>
      <FontAwesomeIcon
        name="fas fa-exclamation-triangle"
        color={Colors.CONTEXT_DANGER_200}
        width={16}
        height={16}
      />{" "}
      <ErrorMessage variant="body1">{ERROR_MESSAGES[errorCode]}</ErrorMessage>
    </ErrorContainer>
  );
}
